import { tap, take, catchError } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject, timer, EMPTY } from 'rxjs';
import * as CanvasJS from './../../assets/js/canvasjs.min.js';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { EstatisticaAcesso } from '../_classes/estatistica-acesso';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { Retorno } from '../_classes/retorno.js';
import { NotificacaoService } from '../_servicos/notificacao.service';

@Component({
  selector: 'app-recurso-estatistica',
  templateUrl: './recurso-estatistica.component.html',
  styleUrls: ['./recurso-estatistica.component.scss'],
})
export class RecursoEstatisticaComponent implements OnInit {
  private readonly recurso: string = 'recurso-estatistica'; //mesmo que a rota
  carregando = false;
  displayedColumns: string[] = ['dsRecurso', 'nrAcessos'];
  dtInicio = new Date();
  dtFim = new Date();

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Retorno>;
  dataSource: MatTableDataSource<EstatisticaAcesso>;

  largura = '800';

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  itensAjuda = [
    {
      titulo: 'Recurso',
      texto: 'Página acessada',
    },
    {
      titulo: 'Total',
      texto: 'Quantidade de vezes',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.atualizarPaginador();
  }

  ngOnInit() {
    this.dtInicio.setDate(this.dtFim.getDate() - 30);
    this.atualizar();
  }

  executarAoCarregarDatasource(x: EstatisticaAcesso[]) {
    this.dataSource = new MatTableDataSource<EstatisticaAcesso>(x);

    let item;
    let qtde = 0;
    let valoresMeus = [];
    x.forEach((e) => {
      item = {
        y: e.nrAcessos,
        label: e.dsRecurso,
      };
      qtde++;
      if (qtde <= 10) {
        valoresMeus.push(item);
      }
    });

    this.atualizarGrafico(valoresMeus);
    this.atualizarPaginador();
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizarPaginador() {
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    //console.log(this.dataSource.filteredData.length + '-' + this.length);
  }

  atualizarGrafico(x) {
    let chart = new CanvasJS.Chart('chartContainer', {
      animationEnabled: true,
      width: this.largura,
      height: 210,
      exportEnabled: true,
      title: {
        text: 'Distribuição dos acessos por recurso (apenas 10 mais)',
      },
      data: [
        {
          type: 'column',
          dataPoints: x,
        },
      ],
    });
    //chart.containerWidth = this.largura;
    chart.render();
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.dataSource$ = this.service
      .listarEstatisticaAcessoComPeriodo3(this.dtInicio, this.dtFim)
      .pipe(
        tap((a: Retorno) => {
          if (a.resultado) {
            this.executarAoCarregarDatasource(a.resultado);
          }
        }),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
